"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestInteractive1 = exports.Samples = void 0;
exports.default = ComponentTest;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _Accordion = _interopRequireDefault(require("react-bootstrap/Accordion"));
var _Card = _interopRequireDefault(require("react-bootstrap/Card"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _reactRouterDom = require("react-router-dom");
var _the_lick = _interopRequireDefault(require("./the_lick.mp3"));
var _cats = _interopRequireDefault(require("./cats.jpg"));
var _cloud = _interopRequireDefault(require("./cloud.jpg"));
var _calfire = _interopRequireDefault(require("./calfire.jpg"));
var _cmajor = _interopRequireDefault(require("./cmajor.png"));
var _background = _interopRequireDefault(require("../assets/background.png"));
var _TestVerticalImage = _interopRequireDefault(require("../assets/TestVerticalImage.png"));
var _ = require("..");
var _TaskMusicViewer = _interopRequireDefault(require("../TaskScaleBuilder/TaskMusicViewer"));
var _MathJax = _interopRequireDefault(require("../MathJax/MathJax"));
var _TaskGraphSliderConfigurable = _interopRequireDefault(require("../TaskGraphSlider/TaskGraphSliderConfigurable"));
////////////////////////////
// This file contains sample questions and best practices for the Interactive Library.
////////////////////////////

var Samples = exports.Samples = {};
var TestInteractive1 = exports.TestInteractive1 = function TestInteractive1() {
  return /*#__PURE__*/_react.default.createElement(_.Navigation, {
    interactiveId: "test"
  }, /*#__PURE__*/_react.default.createElement(_.Page, null, /*#__PURE__*/_react.default.createElement("p", null, "Placeholder")), /*#__PURE__*/_react.default.createElement(_.Page, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _cloud.default,
    alt: "A photo of a cloud, taken from inside a car on a long highway.",
    srCaption: "A roadtrip photo of a cloud that looks like a dolphin."
  })), /*#__PURE__*/_react.default.createElement("p", null, "Placeholder 2")), /*#__PURE__*/_react.default.createElement(_.Page, null, /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    options: ["Apples", "Oranges", "Pears"],
    label: "Select the fruit with the most vitamin C.",
    feedback: [/*#__PURE__*/_react.default.createElement("span", null, "Incorrect. An apple contains 8.4 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Correct. An orange contains 51.1 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Incorrect. A pear contains 7 mg of vitamin C.")],
    correct: 1,
    buttonWidth: "300px"
  })), /*#__PURE__*/_react.default.createElement(_.Page, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal, {
    state: (0, _.Storage)(),
    noReveal: true
  }, "Lorem ipsum dolor", " ", /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal.Passage, {
    contents: "This is the first line of an old latin phrase that is frequently used as text filler."
  }, "sit amet , consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."), " ", "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit ", /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal.Passage, {
    contents: "This is the only English word in the text."
  }, "in"), " voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est ", /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal.Passage, {
    contents: "This is the only English word in the text."
  }, "laborum"), "."))));
};
function ComponentTest(_ref) {
  var component = _ref.component;
  if (component) {
    var Sample = Samples[component];
    return /*#__PURE__*/_react.default.createElement(_.Navigation, {
      interactiveId: "test",
      h1: /*#__PURE__*/_react.default.createElement("h1", null, component)
    }, /*#__PURE__*/_react.default.createElement(_.Page, {
      index: "own-page"
    }, /*#__PURE__*/_react.default.createElement(Sample, {
      key: "own-page"
    })), /*#__PURE__*/_react.default.createElement(_.Page, null, "This is panel 2, to check if state is maintained between panels."), /*#__PURE__*/_react.default.createElement(_.Page, null, "This is panel 3, to check if state is maintained between panels."), /*#__PURE__*/_react.default.createElement(_.Page, null, "This is panel 4, to check if state is maintained between panels."));
  }
  return /*#__PURE__*/_react.default.createElement(_Accordion.default, null, Object.keys(Samples).sort().map(function (v) {
    var Sample = Samples[v];
    if (v.startsWith("_")) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card",
      key: v
    }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Toggle, {
      size: "sm",
      as: _Card.default.Header,
      eventKey: v
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: "/".concat(v)
    }, v)), /*#__PURE__*/_react.default.createElement(_Accordion.default.Collapse, {
      eventKey: v
    }, /*#__PURE__*/_react.default.createElement(_Card.default.Body, null, /*#__PURE__*/_react.default.createElement(_.Navigation, null, /*#__PURE__*/_react.default.createElement(_.Page, {
      index: v
    }, /*#__PURE__*/_react.default.createElement(Sample, {
      key: "accordion-page"
    }))))));
  }));
}
var SamplesAudioPlayer = function SamplesAudioPlayer(props) {
  return /*#__PURE__*/_react.default.createElement(_.AudioPlayer, {
    state: (0, _.Storage)(),
    key: "Q2AP",
    src: _the_lick.default
  });
};
Samples["AudioPlayer"] = SamplesAudioPlayer;
var SamplesVideoPlayer = function SamplesVideoPlayer(props) {
  return /*#__PURE__*/_react.default.createElement(_.VideoPlayer, {
    state: (0, _.Storage)(),
    key: "Q2VP",
    src: _the_lick.default
  });
};
Samples["VideoPlayer"] = SamplesVideoPlayer;
var SamplesTaskChordBuilder = function SamplesTaskChordBuilder(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Line Space Alt Text"), "The following notated triad is missing ", /*#__PURE__*/_react.default.createElement("u", null, "one"), " accidental on either the third or fifth of the chord. First, listen to the audio and determine the triad\u2019s quality, then drag the missing accidental to the correct note on the staff.", /*#__PURE__*/_react.default.createElement(_.TaskChordBuilder, {
    state: (0, _.Storage)(),
    key: "c3",
    musicConfiguration: "X:1;L:1/1;M:;K:Cmin treble",
    musicInitial: "[FAC']",
    correct: "[FA^C']",
    altTextMode: "lineSpace" // other option is lineSpace
    ,
    rangeLower: -7,
    rangeUpper: 19,
    musicDuration: 1000,
    musicButtonNote: true,
    musicButtonNatural: true,
    musicButtonSharp: true,
    musicButtonFlat: true,
    musicButtonDoubleSharp: true,
    musicButtonDoubleFlat: true,
    musicButtonAudio: true,
    feedbackCorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "In an augmented triad, the interval between the root and third is a major third and the interval between the root and fifth is an augmented fifth. So, F\u2013A\u2013", /*#__PURE__*/_react.default.createElement("strong", null, "C\u266F"), " spells an augmented triad on an F root."),
    feedbackIncorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Listen to the triad again. It contains a major third between the root and third. What is the quality of the interval between the root and fifth?")
  }));
};
Samples["TaskChordBuilder"] = SamplesTaskChordBuilder;
var SamplesTaskChordBuilderBass = function SamplesTaskChordBuilderBass(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Pitch Alt Text"), "Add a note to the staff to create a harmonic perfect fifth below C\u266F4.", /*#__PURE__*/_react.default.createElement(_.TaskChordBuilder, {
    state: (0, _.Storage)(),
    key: "c4",
    musicConfiguration: "X:1;L:1/1;M:;K:C bass",
    musicDuration: 1500,
    musicInitial: "[^C]",
    musicButtonNote: true,
    musicButtonSharp: true,
    musicButtonFlat: true,
    musicButtonDoubleFlat: true,
    musicButtonDoubleSharp: true,
    musicButtonNatural: true,
    rangeLower: 0,
    rangeUpper: 12,
    feedbackIncorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Listen to the triad again. It contains a major third between the root and third. What is the quality of the interval between the root and fifth?"),
    answers: [{
      answer: "[^C^F,]",
      correct: true,
      feedback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "One way to write perfect intervals is to learn that almost all perfect intervals will have accidentals that match. The only exception to this rule is when B and F are paired together.")
    }, {
      answer: "[^CF,]",
      correct: false,
      feedback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "This is an augmented fifth. Without changing the given note, how can you turn an augmented fifth into a perfect fifth?")
    }, {
      answer: "[^C^^F,]",
      correct: false,
      feedback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "This is a diminished fifth. Without changing the given note, how can you turn a diminished fifth into a perfect fifth?")
    }, {
      answer: "[^C_G,]",
      correct: false,
      feedback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "While this answer spans the correct number of half steps, it\u2019s not notated as a fifth. Remember that a fifth must span five letter names.")
    }]
  }));
};
Samples["TaskChordBuilder Bass"] = SamplesTaskChordBuilderBass;
var SamplesDesignComponentsModal = function SamplesDesignComponentsModal(props) {
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    showModal = _React$useState2[0],
    setShowModal = _React$useState2[1];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
    className: "bdg-submit-button",
    type: "submit",
    onClick: function onClick() {
      setShowModal(true);
    },
    disabled: showModal
  }, "Show Modal"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Modal, {
    title: "Incorrect.",
    hideTitle: true,
    isOpen: showModal,
    onRequestClose: function onRequestClose() {
      setShowModal(false);
    },
    actions: [/*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
      key: "hide",
      variant: "solid",
      color: "red",
      onClick: function onClick() {
        setShowModal(false);
      }
    }, "Hide Modal")]
  }, /*#__PURE__*/_react.default.createElement("p", null, "Modal body (the show modal button is disabled)"), /*#__PURE__*/_react.default.createElement(_.Figure, {
    alt: "An orange cat and a black cat.",
    src: _cats.default,
    caption: "Lobster (left) and Dashiell (right) laying in a chair."
  })));
};
Samples["DesignComponents.Modal"] = SamplesDesignComponentsModal;
var SamplesDesignComponentsButton = function SamplesDesignComponentsButton(props) {
  var _React$useState3 = _react.default.useState(0),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    num = _React$useState4[0],
    setNum = _React$useState4[1];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
    variant: "solid",
    color: "dark",
    onClick: function onClick() {
      setNum(num + 1);
    }
  }, "button!"), " ", "Score: ", num);
};
Samples["DesignComponents.Button"] = SamplesDesignComponentsButton;
var SamplesDesignComponentsDropdown = function SamplesDesignComponentsDropdown(props) {
  var _React$useState5 = _react.default.useState(""),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    selected = _React$useState6[0],
    setSelected = _React$useState6[1];
  var ref = _react.default.useRef(null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Form.default, {
    inline: true
  }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown, {
    inline: true,
    sort: "ascending",
    label: "In 2014,",
    description: "won an Emmy and recieved widespread critical acclaim.",
    innerClassName: "mx-2"
  }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "0"
  }, "The Office"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "1"
  }, "Community"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "2"
  }, "Friends"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "3"
  }, "Parks and Recreation"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "4"
  }, "How I Met Your Mother"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "5"
  }, "Modern Family"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "6"
  }, "The Big Bang Theory"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "7"
  }, "Arrested Development"))), /*#__PURE__*/_react.default.createElement("p", null, "Controlled dropdown:"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown, {
    innerRef: ref,
    label: "Select a fruit:",
    value: selected,
    onChange: function onChange(e) {
      setSelected(e.target ? e.target.value : e.value);
    }
  }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "0"
  }, "Apple"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "1"
  }, "Orange"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
    value: "2"
  }, "Pear")), /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
    onClick: function onClick() {
      if (ref.current) {
        ref.current.focus();
      }
      setSelected("");
    }
  }, "Reset selected fruit"));
};
Samples["DesignComponents.Dropdown"] = SamplesDesignComponentsDropdown;
var DesignComponentsDesignRow = function DesignComponentsDesignRow(props) {
  return /*#__PURE__*/_react.default.createElement(_DesignComponents.DesignRow, null, "This is some test text.", /*#__PURE__*/_react.default.createElement("p", null, "This is more test text."));
};
Samples["DesignComponents.DesignRow"] = DesignComponentsDesignRow;
var SamplesFigure = function SamplesFigure(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Figure, {
    caption: "Dashiell (left) and Lobster (right) laying in a chair, upside-down.",
    photoCredit: "photo credit",
    alt: "A black cat and an orange cat, upside-down.",
    zoom: true,
    longAlt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This image contains:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "A black cat on the left"), /*#__PURE__*/_react.default.createElement("li", null, "An orange cat on the right"), /*#__PURE__*/_react.default.createElement("li", null, "A flowery pillow, upon which the cats are laying"))),
    src: _cats.default,
    width: "50%"
  }), "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.");
};
Samples["Figure"] = SamplesFigure;
var SamplesImage = function SamplesImage(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Image, {
    photoCredit: "Dashiell (left) and Lobster (right) laying in a chair, upside-down.",
    alt: "A black cat and an orange cat, upside-down.",
    longAlt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This image contains:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "A black cat on the left"), /*#__PURE__*/_react.default.createElement("li", null, "An orange cat on the right"), /*#__PURE__*/_react.default.createElement("li", null, "A flowery pillow, upon which the cats are laying"))),
    src: _cats.default,
    alignment: "center",
    style: {
      maxWidth: "50%"
    }
  }), "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.");
};
Samples["Image"] = SamplesImage;
var SamplesFigureList = function SamplesFigureList(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.FigureList, {
    caption: "Dashiell (left) and Lobster (right) laying in a chair, upside-down.",
    placeContent: "center",
    flexDirection: "row",
    imgHeight: "200"
  }, /*#__PURE__*/_react.default.createElement(_.FigureList.Item, {
    alt: "A black cat and an orange cat, upside-down.",
    longAlt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This image contains:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "A black cat on the left"), /*#__PURE__*/_react.default.createElement("li", null, "An orange cat on the right"), /*#__PURE__*/_react.default.createElement("li", null, "A flowery pillow, upon which the cats are laying"))),
    src: _cats.default
  }), /*#__PURE__*/_react.default.createElement(_.FigureList.Item, {
    alt: "A black cat and an orange cat, upside-down.",
    longAlt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This image contains:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "A black cat on the left"), /*#__PURE__*/_react.default.createElement("li", null, "An orange cat on the right"), /*#__PURE__*/_react.default.createElement("li", null, "A flowery pillow, upon which the cats are laying"))),
    src: _cloud.default
  }), /*#__PURE__*/_react.default.createElement(_.FigureList.Item, {
    alt: "A black cat and an orange cat, upside-down.",
    longAlt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This image contains:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "A black cat on the left"), /*#__PURE__*/_react.default.createElement("li", null, "An orange cat on the right"), /*#__PURE__*/_react.default.createElement("li", null, "A flowery pillow, upon which the cats are laying"))),
    src: _calfire.default
  }), /*#__PURE__*/_react.default.createElement(_.FigureList.Item, {
    alt: "A black cat and an orange cat, upside-down.",
    longAlt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This image contains:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "A black cat on the left"), /*#__PURE__*/_react.default.createElement("li", null, "An orange cat on the right"), /*#__PURE__*/_react.default.createElement("li", null, "A flowery pillow, upon which the cats are laying"))),
    src: _cmajor.default
  })));
};
Samples["FigureList"] = SamplesFigureList;
var SampleTaskGraphSlider = function SampleTaskGraphSlider() {
  var trackRanges = [[{
    min: {
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/2"),
      value: 0.5
    },
    max: 1,
    minAnchor: 0,
    maxAnchor: 50
  }, {
    min: 1,
    max: 2,
    minAnchor: 50,
    maxAnchor: 100
  }], [{
    min: {
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/4"),
      value: 0.25
    },
    max: {
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/2"),
      value: 0.5
    },
    minAnchor: 0,
    maxAnchor: 50
  }, {
    min: {
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/2"),
      value: 0.5
    },
    max: {
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "3/4"),
      value: 0.75
    },
    minAnchor: 50,
    maxAnchor: 100
  }]];
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    a = _useState2[0],
    setA = _useState2[1];
  var _useState3 = (0, _react.useState)(50),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    posA = _useState4[0],
    setPosA = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    k = _useState6[0],
    setK = _useState6[1];
  var _useState7 = (0, _react.useState)(50),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    posK = _useState8[0],
    setPosK = _useState8[1];
  var altText = [[
  // slider 1 alt text
  {
    minRange: 0.99,
    maxRange: 1.01,
    altText: "Three orange indifference curves are asymptotic to the x 1 and x 2 axes. A dashed line runs between the axes at a 45 degree angle. At each point where the dashed line intersects an indifference curve, a straight purple line runs tangent to that curve. "
  }, {
    minRange: 0,
    maxRange: 0.99,
    altText: "As the consumption ratio gets smaller, the dashed line pivots down toward the x 1 axis. The intersection points of the dashed line with the indifference curves slide down the curves, and the three purple tangent lines become flatter. "
  }, {
    minRange: 1.01,
    maxRange: 2.01,
    altText: "As the consumption ratio gets larger, the dashed line pivots up toward the x 2 axis. The intersection points of the dashed line with the indifference curves slide up the curves, and the three purple tangent lines become steeper. "
  }], [
  // slider 2 alt text
  {
    minRange: .48,
    maxRange: .52,
    altText: "The indifference curves are symmetric about a line that runs at 45 degrees between the axes."
  }, {
    minRange: .52,
    maxRange: 1,
    altText: "As the weight share gets smaller, the indifference curves change shape. They become more widely spaced near the right end of the x 1 axis, and more tightly spaced near the upper end of the x 2 axis. The purple tangent lines become flatter."
  }, {
    minRange: 0,
    maxRange: .48,
    altText: "As the weight share gets larger, the indifference curves change shape. They become more tightly spaced near the right end of the x 1 axis, and more widely spaced near the upper end of the x 2 axis. The purple tangent lines become steeper."
  }]];
  var displayText = [{
    sliderRanges: [[1, 1], [1 / 2, 1 / 2]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " A consumption ratio of 1 means that ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "x sub 2 equals x sub 1",
      text: "x_2 = x_1"
    }), ". The two goods are consumed in equal amounts. The line along which this happens runs at 45 degrees between the two axes."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " When good 1 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a equals one half",
      text: "a = 1/2"
    }), ", good 2 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "one minus a equals one half",
      text: "1 - a = 1/2"
    }), ". With the two goods equally weighted, the indifference curves are symmetric about the line ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "x sub 2 equals x sub 1",
      text: "x_2 = x_1"
    }), "."))
  }, {
    sliderRanges: [[1.01, 2], [1 / 2, 1 / 2]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a",
      text: "a"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " consumption ratio (higher consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " When good 1 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a equals one half",
      text: "a = 1/2"
    }), ", good 2 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "one minus a equals one half",
      text: "1 - a = 1/2"
    }), ". With the two goods equally weighted, the indifference curves are symmetric about the line ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "x sub 2 equals x sub 1",
      text: "x_2 = x_1"
    }), "."))
  }, {
    sliderRanges: [[1 / 2, .99], [.5, .5]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a",
      text: "a"
    }), ", the absolute value of the MRS is\xA0", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " consumption ratio (lower consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " When good 1 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a equals one half",
      text: "a = 1/2"
    }), ", good 2 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "one minus a equals one half",
      text: "1 - a = 1/2"
    }), ". With the two goods equally weighted, the indifference curves are symmetric about the line ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "x sub 2 equals x sub 1",
      text: "x_2 = x_1"
    }), "."))
  }, {
    sliderRanges: [[1, 1], [.51, 3 / 4]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " A consumption ratio of 1 means that ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "x sub 2 equals x sub 1",
      text: "x_2 = x_1"
    }), ". The two goods are consumed in equal amounts. The line along which this happens runs at 45 degrees between the two axes."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
      scale: 1.3,
      text: "(\\frac{x_2}{x_1})"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable."))
  }, {
    sliderRanges: [[1, 1], [1 / 4, .49]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " A consumption ratio of 1 means that ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "x sub 2 equals x sub 1",
      text: "x_2 = x_1"
    }), ". The two goods are consumed in equal amounts. The line along which this happens runs at 45 degrees between the two axes."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
      scale: 1.3,
      text: "(\\frac{x_2}{x_1})"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable."))
  }, {
    sliderRanges: [[1 / 2, .99], [1 / 4, .49]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a",
      text: "a"
    }), ", the absolute value of the MRS is\xA0", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " consumption ratio (lower consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
      scale: 1.3,
      text: "(\\frac{x_2}{x_1})"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable."))
  }, {
    sliderRanges: [[1.01, 2], [1 / 4, .49]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a",
      text: "a"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " consumption ratio (higher consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
      scale: 1.3,
      text: "(\\frac{x_2}{x_1})"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable."))
  }, {
    sliderRanges: [[1 / 2, .99], [.51, 3 / 4]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a",
      text: "a"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " consumption ratio (lower consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
      scale: 1.3,
      text: "(\\frac{x_2}{x_1})"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable."))
  }, {
    sliderRanges: [[1.01, 2], [.51, 3 / 4]],
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "a",
      text: "a"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " consumption ratio (higher consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
      scale: 1.3,
      text: "(\\frac{x_2}{x_1})"
    }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable."))
  }];
  var numberOfPoints = 30;
  var data1 = [];
  var data2 = [];
  var data3 = [];
  var data4 = [];
  var data5 = [];
  var data6 = [];
  var data7 = [];
  var kToTheA = Math.pow(k, a);
  for (var x = 0; x < numberOfPoints; x += .5) {
    data1.push({
      x: x,
      y: k * x
    });
    data2.push({
      x: x,
      y: 5 * kToTheA + 5 * a * kToTheA / (1 - a) - a * k * x / (1 - a)
    });
    data3.push({
      x: x,
      y: 10 * kToTheA + 10 * a * kToTheA / (1 - a) - a * k * x / (1 - a)
    });
    data4.push({
      x: x,
      y: 15 * kToTheA + 15 * a * kToTheA / (1 - a) - a * k * x / (1 - a)
    });
    data5.push({
      x: x,
      y: Math.pow(5 * Math.pow(x, -a), 1 / (1 - a))
    });
    data6.push({
      x: x,
      y: Math.pow(10 * Math.pow(x, -a), 1 / (1 - a))
    });
    data7.push({
      x: x,
      y: Math.pow(15 * Math.pow(x, -a), 1 / (1 - a))
    });
  }
  var points = [{
    x: 5 * Math.pow(k, a - 1),
    y: 5 * Math.pow(k, a)
  }, {
    x: 10 * Math.pow(k, a - 1),
    y: 10 * Math.pow(k, a)
  }, {
    x: 15 * Math.pow(k, a - 1),
    y: 15 * Math.pow(k, a)
  }];
  var colorLightPurple = "rgb(238,130,238)";
  var colorOrange = "rgb(255,165,0)";
  var dataSet = {
    datasets: [{
      label: 'Equation 1',
      data: data1,
      fill: false,
      borderColor: '#595959',
      borderDash: [10, 5],
      pointRadius: 0,
      showLine: true
    }, {
      label: 'Equation 2',
      data: data2,
      fill: false,
      borderColor: colorLightPurple,
      pointRadius: 0,
      showLine: true
    }, {
      label: 'Equation 3',
      data: data3,
      fill: false,
      borderColor: colorLightPurple,
      pointRadius: 0,
      showLine: true
    }, {
      label: 'Equation 4',
      data: data4,
      fill: false,
      borderColor: colorLightPurple,
      pointRadius: 0,
      showLine: true
    }, {
      label: 'Equation 5',
      data: data5,
      fill: false,
      borderColor: colorOrange,
      pointRadius: 0,
      showLine: true
    }, {
      label: 'Equation 6',
      data: data6,
      fill: false,
      borderColor: colorOrange,
      pointRadius: 0,
      showLine: true
    }, {
      label: 'Equation 7',
      data: data7,
      fill: false,
      borderColor: colorOrange,
      pointRadius: 0,
      showLine: true
    }, {
      label: 'Fixed points',
      data: points,
      fill: true,
      borderColor: 'rgb(0, 0, 0)',
      backgroundColor: 'rgb(0, 0, 0)',
      borderDash: [0, 10]
    }]
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Cobb-Douglas Preferences and the Marginal Rate of Substitution"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "The graph shows three orange indifference curves for a consumer with weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "a",
    text: "a"
  }), " for good 1. The dashed line represents all consumption bundles with the same consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
    scale: 1.3,
    text: "(\\frac{x_2}{x_1})"
  }), ". There are three consumption bundles with the same consumption ratio, one on each indifference curve. The MRS at those consumption bundles is captured by the slope of the purple tangent lines. The purple lines are parallel, indicating the same MRS for all three bundles."), /*#__PURE__*/_react.default.createElement("p", null, "On the following graph, adjust the consumption ratio value ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
    scale: 1.3,
    text: "(\\frac{x_2}{x_1})"
  }), " to examine how, for a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "a",
    text: "a"
  }), ", the MRS changes as the consumption ratio changes. Now adjust the weight share value ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "Parentheses a EndParentheses",
    text: "(a)"
  }), " to examine how the indifference curves change shape, and again note how the MRS is affected. Continue exploring until you have tried all nine ways of combining the left-middle-right settings of the two sliders.")), /*#__PURE__*/_react.default.createElement(_.TaskGraphSlider, {
    state: (0, _.Storage)(),
    graphs: [{
      data: dataSet,
      canvasAltText: "Graph of MRS",
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        scales: {
          x: {
            min: 0,
            max: 30,
            title: {
              display: true,
              text: "x₁",
              color: "#6E6E6E",
              align: "end",
              font: {
                size: 18
              }
            },
            grid: {
              display: true,
              drawOnChartArea: false,
              drawTicks: true
            },
            ticks: {
              callback: function callback(val, index) {
                return val % 5 === 0 ? val : '';
              }
            }
          },
          y: {
            min: 0,
            max: 30,
            title: {
              display: true,
              text: "x₂",
              color: "#6E6E6E",
              align: "end",
              font: {
                size: 18
              }
            },
            grid: {
              display: true,
              drawOnChartArea: false,
              drawTicks: true
            }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    }],
    trackRanges: trackRanges,
    displayText: displayText,
    altTextRanges: altText,
    sliders: [{
      value: k,
      setValue: setK,
      position: posK,
      setPosition: setPosK,
      initialPosition: 50,
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          textAlign: "center",
          textSize: "16px",
          marginBottom: "5px"
        }
      }, "Consumption Ratio, ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Frac x Sub 2 Over x Sub 1 EndFrac",
        scale: 1.3,
        text: "\\frac{x_2}{x_1}"
      }), /*#__PURE__*/_react.default.createElement("br", null), "(Logarithmic Scale)")),
      ariaLabelForHandle: "Choose a value for variable k."
    }, {
      value: a,
      setValue: setA,
      position: posA,
      setPosition: setPosA,
      initialPosition: 50,
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          textAlign: "center",
          textSize: "16px",
          marginBottom: "5px"
        }
      }, "Cobb-Douglas Weight Share, ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }))),
      ariaLabelForHandle: "Choose a value for variable a."
    }]
  }));
};
Samples["TaskGraphSlider"] = SampleTaskGraphSlider;
var SampleTaskGraphSliderConfigurable = function SampleTaskGraphSliderConfigurable() {
  var colorLightPurple = "rgb(238,130,238)";
  var colorOrange = "rgb(255,165,0)";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Cobb-Douglas Preferences and the Marginal Rate of Substitution"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "The graph shows three orange indifference curves for a consumer with weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "a",
    text: "a"
  }), " for good 1. The dashed line represents all consumption bundles with the same consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
    scale: 1.3,
    text: "(\\frac{x_2}{x_1})"
  }), ". There are three consumption bundles with the same consumption ratio, one on each indifference curve. The MRS at those consumption bundles is captured by the slope of the purple tangent lines. The purple lines are parallel, indicating the same MRS for all three bundles."), /*#__PURE__*/_react.default.createElement("p", null, "On the following graph, adjust the consumption ratio value ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
    scale: 1.3,
    text: "(\\frac{x_2}{x_1})"
  }), " to examine how, for a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "a",
    text: "a"
  }), ", the MRS changes as the consumption ratio changes. Now adjust the weight share value ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    alt: "Parentheses a EndParentheses",
    text: "(a)"
  }), " to examine how the indifference curves change shape, and again note how the MRS is affected. Continue exploring until you have tried all nine ways of combining the left-middle-right settings of the two sliders.")), /*#__PURE__*/_react.default.createElement(_TaskGraphSliderConfigurable.default, {
    state: (0, _.Storage)(),
    spaceBetweenPoints: 0.5,
    equations: [[{
      label: 'eq1',
      yEquals: 'a * x',
      borderColor: '#595959',
      borderDash: [10, 5]
    }, {
      label: 'eq2',
      yEquals: '5 * Math.pow(a, b) + ((5 * b * Math.pow(a, b)) / (1 - b)) - ((b * a * x) / (1 - b))',
      borderColor: colorLightPurple
    }, {
      label: 'eq3',
      yEquals: '10 * Math.pow(a, b) + ((10 * b * Math.pow(a, b)) / (1 - b)) - ((b * a * x) / (1 - b))',
      borderColor: colorLightPurple
    }, {
      label: 'eq4',
      yEquals: '15 * Math.pow(a, b) + ((15 * b * Math.pow(a, b)) / (1 - b)) - ((b * a * x) / (1 - b))',
      borderColor: colorLightPurple
    }, {
      label: 'eq5',
      yEquals: 'Math.pow(5 * Math.pow(x, -b), (1 / (1 - b)))',
      borderColor: colorOrange
    }, {
      label: 'eq6',
      yEquals: 'Math.pow(10 * Math.pow(x, -b), (1 / (1 - b)))',
      borderColor: colorOrange
    }, {
      label: 'eq7',
      yEquals: 'Math.pow(15 * Math.pow(x, -b), (1 / (1 - b)))',
      borderColor: colorOrange
    }]],
    pointSets: [
    // graphs
    [
    // pointsets
    [
    // points
    {
      xEquals: '5 * Math.pow(a, b - 1)',
      yEquals: '5 * Math.pow(a, b)'
    }, {
      xEquals: '10 * Math.pow(a, b - 1)',
      yEquals: '10 * Math.pow(a, b)'
    }, {
      xEquals: '15 * Math.pow(a, b - 1)',
      yEquals: '15 * Math.pow(a, b)'
    }]]],
    graphs: [{
      canvasAltText: "Graph of MRS",
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        scales: {
          x: {
            min: 0,
            max: 30,
            title: {
              text: "x₁"
            },
            tickInterval: 5
          },
          y: {
            min: 0,
            max: 30,
            title: {
              text: "x₂"
            },
            tickInterval: 5
          }
        }
      }
    }],
    trackRanges: [[{
      min: {
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/2"),
        value: 0.5
      },
      max: 1,
      minAnchor: 0,
      maxAnchor: 50
    }, {
      min: 1,
      max: 2,
      minAnchor: 50,
      maxAnchor: 100
    }], [{
      min: {
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/4"),
        value: 0.25
      },
      max: {
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/2"),
        value: 0.5
      },
      minAnchor: 0,
      maxAnchor: 50
    }, {
      min: {
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1/2"),
        value: 0.5
      },
      max: {
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "3/4"),
        value: 0.75
      },
      minAnchor: 50,
      maxAnchor: 100
    }]],
    texts: [{
      sliderRanges: [[1, 1], [1 / 2, 1 / 2]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " A consumption ratio of 1 means that ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "x sub 2 equals x sub 1",
        text: "x_2 = x_1"
      }), ". The two goods are consumed in equal amounts. The line along which this happens runs at 45 degrees between the two axes."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " When good 1 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a equals one half",
        text: "a = 1/2"
      }), ", good 2 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "one minus a equals one half",
        text: "1 - a = 1/2"
      }), ". With the two goods equally weighted, the indifference curves are symmetric about the line ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "x sub 2 equals x sub 1",
        text: "x_2 = x_1"
      }), ".")),
      altText: "Three orange indifference curves are asymptotic to the x 1 and x 2 axes. A dashed line runs between the axes at a 45 degree angle. At each point where the dashed line intersects an indifference curve, a straight purple line runs tangent to that curve. The indifference curves are symmetric about a line that runs at 45 degrees between the axes."
    }, {
      sliderRanges: [[1.01, 2], [1 / 2, 1 / 2]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " consumption ratio (higher consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " When good 1 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a equals one half",
        text: "a = 1/2"
      }), ", good 2 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "one minus a equals one half",
        text: "1 - a = 1/2"
      }), ". With the two goods equally weighted, the indifference curves are symmetric about the line ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "x sub 2 equals x sub 1",
        text: "x_2 = x_1"
      }), ".")),
      altText: "As the consumption ratio gets larger, the dashed line pivots up toward the x 2 axis. The intersection points of the dashed line with the indifference curves slide up the curves, and the three purple tangent lines become steeper. The indifference curves are symmetric about a line that runs at 45 degrees between the axes."
    }, {
      sliderRanges: [[1 / 2, .99], [.5, .5]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }), ", the absolute value of the MRS is\xA0", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " consumption ratio (lower consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " When good 1 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a equals one half",
        text: "a = 1/2"
      }), ", good 2 gets a weight share of ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "one minus a equals one half",
        text: "1 - a = 1/2"
      }), ". With the two goods equally weighted, the indifference curves are symmetric about the line ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "x sub 2 equals x sub 1",
        text: "x_2 = x_1"
      }), ".")),
      altText: "As the consumption ratio gets smaller, the dashed line pivots down toward the x 1 axis. The intersection points of the dashed line with the indifference curves slide down the curves, and the three purple tangent lines become flatter. The indifference curves are symmetric about a line that runs at 45 degrees between the axes."
    }, {
      sliderRanges: [[1, 1], [.51, 3 / 4]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " A consumption ratio of 1 means that ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "x sub 2 equals x sub 1",
        text: "x_2 = x_1"
      }), ". The two goods are consumed in equal amounts. The line along which this happens runs at 45 degrees between the two axes."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
        scale: 1.3,
        text: "(\\frac{x_2}{x_1})"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable.")),
      altText: "Three orange indifference curves are asymptotic to the x 1 and x 2 axes. A dashed line runs between the axes at a 45 degree angle. At each point where the dashed line intersects an indifference curve, a straight purple line runs tangent to that curve. As the weight share gets smaller, the indifference curves change shape. They become more widely spaced near the right end of the x 1 axis, and more tightly spaced near the upper end of the x 2 axis. The purple tangent lines become flatter."
    }, {
      sliderRanges: [[1, 1], [1 / 4, .49]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " A consumption ratio of 1 means that ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "x sub 2 equals x sub 1",
        text: "x_2 = x_1"
      }), ". The two goods are consumed in equal amounts. The line along which this happens runs at 45 degrees between the two axes."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
        scale: 1.3,
        text: "(\\frac{x_2}{x_1})"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable.")),
      altText: "Three orange indifference curves are asymptotic to the x 1 and x 2 axes. A dashed line runs between the axes at a 45 degree angle. At each point where the dashed line intersects an indifference curve, a straight purple line runs tangent to that curve. As the weight share gets larger, the indifference curves change shape. They become more tightly spaced near the right end of the x 1 axis, and more widely spaced near the upper end of the x 2 axis. The purple tangent lines become steeper."
    }, {
      sliderRanges: [[1 / 2, .99], [1 / 4, .49]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }), ", the absolute value of the MRS is\xA0", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " consumption ratio (lower consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
        scale: 1.3,
        text: "(\\frac{x_2}{x_1})"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable.")),
      altText: "As the consumption ratio gets smaller, the dashed line pivots down toward the x 1 axis. The intersection points of the dashed line with the indifference curves slide down the curves, and the three purple tangent lines become flatter. As the weight share gets larger, the indifference curves change shape. They become more tightly spaced near the right end of the x 1 axis, and more widely spaced near the upper end of the x 2 axis. The purple tangent lines become steeper."
    }, {
      sliderRanges: [[1.01, 2], [1 / 4, .49]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " consumption ratio (higher consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
        scale: 1.3,
        text: "(\\frac{x_2}{x_1})"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable.")),
      altText: "As the consumption ratio gets larger, the dashed line pivots up toward the x 2 axis. The intersection points of the dashed line with the indifference curves slide up the curves, and the three purple tangent lines become steeper. As the weight share gets larger, the indifference curves change shape. They become more tightly spaced near the right end of the x 1 axis, and more widely spaced near the upper end of the x 2 axis. The purple tangent lines become steeper."
    }, {
      sliderRanges: [[1 / 2, .99], [.51, 3 / 4]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " (flatter slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), " consumption ratio (lower consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "less"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
        scale: 1.3,
        text: "(\\frac{x_2}{x_1})"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable.")),
      altText: "As the consumption ratio gets smaller, the dashed line pivots down toward the x 1 axis. The intersection points of the dashed line with the indifference curves slide down the curves, and the three purple tangent lines become flatter. As the weight share gets smaller, the indifference curves change shape. They become more widely spaced near the right end of the x 1 axis, and more tightly spaced near the upper end of the x 2 axis. The purple tangent lines become flatter."
    }, {
      sliderRanges: [[1.01, 2], [.51, 3 / 4]],
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Consumption Ratio:"), " For a given weight share ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) for a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " consumption ratio (higher consumption of good 2 relative to good 1): good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable when its consumption relative to good 2 is ", /*#__PURE__*/_react.default.createElement("b", null, "lower"), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Weight Share:"), " For a given consumption ratio ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Parentheses Frac x Sub 2 Over x Sub 1 EndFrac EndParentheses",
        scale: 1.3,
        text: "(\\frac{x_2}{x_1})"
      }), ", the absolute value of the MRS is ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " (steeper slope) when preferences exhibit a ", /*#__PURE__*/_react.default.createElement("b", null, "higher"), " weight share for good 1: good 1 is relatively ", /*#__PURE__*/_react.default.createElement("b", null, "more"), " valuable.")),
      altText: "As the consumption ratio gets larger, the dashed line pivots up toward the x 2 axis. The intersection points of the dashed line with the indifference curves slide up the curves, and the three purple tangent lines become steeper. As the weight share gets smaller, the indifference curves change shape. They become more widely spaced near the right end of the x 1 axis, and more tightly spaced near the upper end of the x 2 axis. The purple tangent lines become flatter."
    }],
    sliders: [{
      initialPosition: 50,
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          textAlign: "center",
          textSize: "16px",
          marginBottom: "5px"
        }
      }, "Consumption Ratio, ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "Frac x Sub 2 Over x Sub 1 EndFrac",
        scale: 1.3,
        text: "\\frac{x_2}{x_1}"
      }), /*#__PURE__*/_react.default.createElement("br", null), "(Logarithmic Scale)")),
      ariaLabelForHandle: "Choose a value for variable k."
    }, {
      initialPosition: 50,
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          textAlign: "center",
          textSize: "16px",
          marginBottom: "5px"
        }
      }, "Cobb-Douglas Weight Share, ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
        alt: "a",
        text: "a"
      }))),
      ariaLabelForHandle: "Choose a value for variable a."
    }]
  }));
};
Samples["TaskGraphSliderConfigurable"] = SampleTaskGraphSliderConfigurable;
var SamplesShrinkToFit = function SamplesShrinkToFit(props) {
  var _React$useState7 = _react.default.useState(0),
    _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
    num = _React$useState8[0],
    setNum = _React$useState8[1];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, num, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '400px',
      width: '200px',
      overflow: 'scroll'
    }
  }, new Array(10).fill(0).map(function (i, k) {
    return /*#__PURE__*/_react.default.createElement(_.ShrinkToFit, {
      key: k,
      onClick: function onClick() {}
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg?".concat(Math.random()),
      alt: ""
    }));
  })), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      setNum(Math.random());
    }
  }, "Re-render"));
};
Samples["ShrinkToFit"] = SamplesShrinkToFit;
var SamplesTaskAnimation = function SamplesTaskAnimation(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Here is a short animation.", /*#__PURE__*/_react.default.createElement(_.TaskAnimation, {
    state: (0, _.Storage)(),
    frametime: 1,
    accessibleLabel: "Example Animation",
    hidePlayButton: true
  }, /*#__PURE__*/_react.default.createElement(_.TaskAnimation.Frame, {
    title: "Hello (1 of 3)"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '250px',
      height: '50px',
      margin: 'auto',
      backgroundColor: 'lightblue'
    }
  }, "1: |")), /*#__PURE__*/_react.default.createElement(_.TaskAnimation.Frame, {
    frametime: 3,
    title: "Hello (2 of 3)"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '250px',
      height: '50px',
      margin: 'auto',
      backgroundColor: 'lightblue'
    }
  }, "2: /")), /*#__PURE__*/_react.default.createElement(_.TaskAnimation.Frame, {
    title: "Hello (3 of 3)"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '250px',
      height: '50px',
      margin: 'auto',
      backgroundColor: 'lightblue'
    }
  }, "3: \u2013"))));
};
Samples["TaskAnimation"] = SamplesTaskAnimation;
var SamplesTaskBlank = function SamplesTaskBlank(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "The answers are \"apple\" and \"2\"."), /*#__PURE__*/_react.default.createElement(_.TaskBlank, {
    state: (0, _.Storage)(),
    answer: "apple",
    label: "What fruit is red and sometimes green?"
  }), /*#__PURE__*/_react.default.createElement(_.TaskBlank, {
    state: (0, _.Storage)(),
    answer: "2",
    prepend: "$",
    inline: true,
    label: "The apple costs ",
    description: " at the store."
  }));
};
Samples["TaskBlank"] = SamplesTaskBlank;
var SamplesTaskButton = function SamplesTaskButton(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskButton, {
    state: (0, _.Storage)(),
    text: "[PUSH THE BUTTON]"
  });
};
Samples["TaskButton"] = SamplesTaskButton;
var SamplesTaskCallout = function SamplesTaskCallout(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskCallout, {
    state: (0, _.Storage)(),
    picture: _cloud.default,
    details: "Lobster (left) and Dashiell (right) laying in a chair.",
    alt: "An orange cat and a black cat.",
    detailsName: "panel2desc",
    hotspots: [{
      content: /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Dashiell"), /*#__PURE__*/_react.default.createElement("li", null, "black"), /*#__PURE__*/_react.default.createElement("li", null, "November 2019")),
      label: "Dashiell",
      style: {
        top: "100px",
        left: "300px",
        width: "50px",
        height: "70px"
      },
      shape: "Circle"
    }, {
      content: /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Lobster"), /*#__PURE__*/_react.default.createElement("li", null, "orange"), /*#__PURE__*/_react.default.createElement("li", null, "October 2020")),
      label: "Lobster",
      style: {
        top: "50px",
        left: "160px",
        width: "70px",
        height: "70px"
      },
      shape: "Square"
    }]
  });
};
Samples["TaskCallout"] = SamplesTaskCallout;
var SamplesTaskCarousel = function SamplesTaskCarousel(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskCarousel, {
    state: (0, _.Storage)(),
    items: [/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskMultiSelect, {
      state: (0, _.Storage)(),
      prompt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Select all fruits that are red"),
      data: [{
        label: /*#__PURE__*/_react.default.createElement("span", null, "Strawberry ", /*#__PURE__*/_react.default.createElement("i", null, "(correct answer)")),
        correct: true
      }, {
        label: "Pomegranate (correct answer)",
        correct: true
      }, {
        label: "Orange",
        correct: false
      }, {
        label: /*#__PURE__*/_react.default.createElement("span", null, "Watermelon"),
        correct: false
      }, {
        label: /*#__PURE__*/_react.default.createElement("span", null, "Banana"),
        correct: false
      }],
      correctFeedback: "Correct.",
      incorrectFeedback: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("i", null, " Try again")),
      maxAttempts: 2,
      randomize: true
    })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskTabPanel, {
      state: (0, _.Storage)(),
      label: "Cat pictures",
      contents: [{
        title: "Tab 1",
        contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "hi", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
          caption: "Lobster (left) and Dashiell (right) laying in a chair.",
          alt: "An orange cat and a black cat.",
          src: _cats.default,
          width: "100%",
          style: {
            transform: "scaleX(1)"
          }
        }))
      }, {
        title: "Tab 2",
        contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "hello", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
          caption: "Dashiell (left) and Lobster (right) laying in a chair.",
          alt: "A black cat and an orange cat.",
          src: _cats.default,
          width: "100%",
          style: {
            transform: "scaleX(-1)"
          }
        }))
      }, {
        title: "Tab 3 Very Long Title",
        contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "goodbye", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
          caption: "Lobster (left) and Dashiell (right) laying in a chair, upside-down.",
          alt: "An orange cat and a black cat, upside-down.",
          src: _cats.default,
          width: "100%",
          style: {
            transform: "scaleY(-1)"
          }
        }))
      }, {
        title: "Tab 4",
        contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "bye", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
          caption: "Dashiell (left) and Lobster (right) laying in a chair, upside-down.",
          alt: "A black cat and an orange cat, upside-down.",
          src: _cats.default,
          width: "100%",
          style: {
            transform: "scaleX(-1) scaleY(-1)"
          }
        }))
      }]
    })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "goodbye", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
      caption: "Lobster (left) and Dashiell (right) laying in a chair, upside-down.",
      alt: "An orange cat and a black cat, upside-down.",
      src: _cats.default,
      width: "50%",
      style: {
        transform: "scaleY(-1)"
      }
    })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "bye", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
      caption: "Dashiell (left) and Lobster (right) laying in a chair, upside-down.",
      alt: "A black cat and an orange cat, upside-down.",
      src: _cats.default,
      width: "50%",
      style: {
        transform: "scaleX(-1) scaleY(-1)"
      }
    }))]
  });
};
Samples["TaskCarousel"] = SamplesTaskCarousel;
var SamplesTaskDragDropHoriz = function SamplesTaskDragDropHoriz(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskDragDrop, {
    state: (0, _.Storage)(),
    responsive: true,
    sort: true,
    textAdjust: true,
    dropdownPlacement: "auto",
    key: "TDD5",
    choices: [{
      content: /*#__PURE__*/_react.default.createElement("i", null, "Cats"),
      accessibleLabel: "Cats"
    }, {
      content: /*#__PURE__*/_react.default.createElement("i", null, "Fire"),
      accessibleLabel: "Fire"
    }, {
      content: /*#__PURE__*/_react.default.createElement("i", null, "Cloud"),
      accessibleLabel: "Cloud"
    }],
    feedbackCorrect: "Correct! You've completed the task.",
    feedbackIncorrect: "Incorrect. That doesn't go there.",
    hotspots: [{
      correct: [0],
      hotspotLabel: "Cats",
      style: {
        top: "50px",
        left: "30px",
        right: "30px",
        height: "80px"
      }
    }, {
      correct: [2],
      hotspotLabel: "Cloud",
      style: {
        top: "50px",
        left: "30px",
        right: "30px",
        height: "80px"
      }
    }, {
      correct: [1],
      hotspotLabel: "Fire",
      style: {
        top: "50px",
        left: "30px",
        right: "30px",
        height: "80px"
      }
    }]
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("h3", null, "Cats"), /*#__PURE__*/_react.default.createElement(_.Figure, {
    srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
    alt: "An orange cat and a black cat.",
    src: _cats.default,
    width: "167"
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 0
  })), /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("h3", null, "Clouds"), /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _cloud.default,
    alt: "A photo of a cloud, taken from inside a car on a long highway.",
    srCaption: "A roadtrip photo of a cloud that looks like a dolphin.",
    width: "167"
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 1
  })), /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("h3", null, "Fires"), /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _calfire.default,
    alt: "A photo of the sun. Smoke in the air turns the light red.",
    srCaption: "A photo of the sun during the 2020 California wildfire season.",
    width: "167"
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 2
  }))));
};
Samples["TaskDragDrop Horizontal"] = SamplesTaskDragDropHoriz;
var SamplesTaskDragDropVert = function SamplesTaskDragDropVert(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskDragDrop, {
    state: (0, _.Storage)(),
    responsive: true,
    vertical: true,
    labelWidth: "100%",
    choices: [{
      content: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Needle 3"), /*#__PURE__*/_react.default.createElement(_.Figure, {
        srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
        alt: "An orange cat and a black cat.",
        src: _cats.default,
        style: {
          width: "100%"
        }
      })),
      accessible: "cat3",
      accessibleLabel: "Cat 3"
    }, {
      content: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Needle 2"), /*#__PURE__*/_react.default.createElement(_.Figure, {
        srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
        alt: "An orange cat and a black cat.",
        src: _cats.default,
        style: {
          width: "100%"
        }
      })),
      accessible: "cat2",
      accessibleLabel: "Cat 2"
    }, {
      content: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Needle 1"), /*#__PURE__*/_react.default.createElement(_.Figure, {
        srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
        alt: "An orange cat and a black cat.",
        src: _cats.default,
        style: {
          width: "100%"
        }
      })),
      accessible: "cat1",
      accessibleLabel: "Cat 1"
    }],
    feedback: [["Incorrect!", "Incorrect!", "Correct!"], ["Incorrect!", "Correct!", "Incorrect!"], ["Correct!", "Incorrect!", "Incorrect!"]],
    hotspots: [{
      correct: [2],
      hotspotLabel: "step 1",
      style: {
        top: "70px",
        left: "125px",
        width: "100px",
        height: "100px"
      }
    }, {
      correct: [1],
      hotspotLabel: "step 2",
      style: {
        top: "300px",
        left: "125px",
        width: "100px",
        height: "100px"
      }
    }, {
      correct: [0],
      hotspotLabel: "step 3",
      style: {
        top: "570px",
        left: "125px",
        width: "100px",
        height: "100px"
      }
    }]
  }, "hello inner text", /*#__PURE__*/_react.default.createElement(_.Figure, {
    srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
    className: "mb-0",
    alt: "An orange cat and a black cat.",
    src: _cats.default,
    width: "300px",
    style: {
      display: "block"
    }
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 0
  }), /*#__PURE__*/_react.default.createElement(_.Figure, {
    srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
    className: "mb-0",
    alt: "An orange cat and a black cat.",
    src: _cats.default,
    width: "300px",
    style: {
      display: "block"
    }
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 1
  }), /*#__PURE__*/_react.default.createElement(_.Figure, {
    srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
    className: "mb-0",
    alt: "An orange cat and a black cat.",
    src: _cats.default,
    width: "300px",
    style: {
      display: "block"
    }
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 2
  }), "hello inner text");
};
Samples["TaskDragDrop Vertical"] = SamplesTaskDragDropVert;
var SamplesTaskDragDropPicture = function SamplesTaskDragDropPicture(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskDragDrop, {
    state: (0, _.Storage)(),
    picture: _cats.default,
    pictureAlt: "An orange cat and a black cat.",
    sort: true,
    textAdjust: true,
    dropdownPlacement: "auto",
    key: "TDD5",
    choices: [{
      content: /*#__PURE__*/_react.default.createElement("i", null, "Cats"),
      accessibleLabel: "Cats"
    }, {
      content: /*#__PURE__*/_react.default.createElement("i", null, "Fire"),
      accessibleLabel: "Fire"
    }, {
      content: /*#__PURE__*/_react.default.createElement("i", null, "Cloud"),
      accessibleLabel: "Cloud"
    }],
    feedbackCorrect: "Correct! You've completed the task.",
    feedbackIncorrect: "Incorrect. That doesn't go there.",
    hotspots: [{
      correct: [0],
      hotspotLabel: "Cats",
      style: {
        top: "50px",
        left: "30px",
        right: "30px",
        height: "80px"
      }
    }, {
      correct: [2],
      hotspotLabel: "Cloud",
      style: {
        top: "150px",
        left: "30px",
        right: "30px",
        height: "80px"
      }
    }, {
      correct: [1],
      hotspotLabel: "Fire",
      style: {
        top: "250px",
        left: "30px",
        right: "30px",
        height: "80px"
      }
    }]
  });
};
Samples["TaskDragDrop Picture"] = SamplesTaskDragDropPicture;
var SamplesTaskDragDropDropdownsOnly = function SamplesTaskDragDropDropdownsOnly(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskDragDrop, {
    state: (0, _.Storage)(),
    onlyDropdown: true,
    dropdownPlacement: "auto",
    key: "TDD5",
    choices: [{
      content: /*#__PURE__*/_react.default.createElement("i", null, "Cats"),
      accessibleLabel: "Cats"
    }, {
      content: /*#__PURE__*/_react.default.createElement("i", null, "Fire"),
      accessibleLabel: "Fire"
    }, {
      content: /*#__PURE__*/_react.default.createElement("i", null, "Cloud"),
      accessibleLabel: "Cloud"
    }],
    feedbackCorrect: "Correct! You've completed the task.",
    feedbackIncorrect: "Incorrect. That doesn't go there.",
    hotspots: [{
      correct: [0],
      hotspotLabel: "Cats",
      style: {
        position: 'relative',
        height: "80px"
      }
    }, {
      correct: [2],
      hotspotLabel: "Cloud",
      style: {
        position: 'relative',
        height: "80px"
      }
    }, {
      correct: [1],
      hotspotLabel: "Fire",
      style: {
        position: 'relative',
        height: "80px"
      }
    }]
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("h3", null, "Cats"), /*#__PURE__*/_react.default.createElement(_.Figure, {
    srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
    alt: "An orange cat and a black cat.",
    src: _cats.default,
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 0
  })), /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("h3", null, "Clouds"), /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _cloud.default,
    alt: "A photo of a cloud, taken from inside a car on a long highway.",
    srCaption: "A roadtrip photo of a cloud that looks like a dolphin.",
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 1
  })), /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("h3", null, "Fires"), /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _calfire.default,
    alt: "A photo of the sun. Smoke in the air turns the light red.",
    srCaption: "A photo of the sun during the 2020 California wildfire season.",
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, {
    index: 2
  }))));
};
Samples["TaskDragDrop Dropdowns Only"] = SamplesTaskDragDropDropdownsOnly;
var SamplesTaskDragDropSubmit = function SamplesTaskDragDropSubmit(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskDragDrop, {
    state: (0, _.Storage)(),
    labelWidth: "155px",
    labelHeight: "100px",
    responsive: true,
    submit: true,
    choices: [{
      content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          color: "white",
          margin: "0px 0px"
        }
      }, "Graph A"), /*#__PURE__*/_react.default.createElement(_.Figure, {
        className: "drag_drop_graph",
        srCaption: "placeholder",
        alt: "placeholder",
        src: _cats.default,
        style: {
          width: "180px"
        }
      })),
      accessible: "placeholder",
      accessibleLabel: "The indifference curve becomes less steep at (x1, x2)."
    }, {
      content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          color: "white",
          margin: "0px 0px"
        }
      }, "Graph B"), /*#__PURE__*/_react.default.createElement(_.Figure, {
        className: "drag_drop_graph",
        srCaption: "placeholder",
        alt: "placeholder",
        src: _cloud.default,
        style: {
          width: "180px"
        }
      })),
      accessible: "placeholder",
      accessibleLabel: "The curvature of the indifference curves decreases."
    }, {
      content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          color: "white",
          margin: "0px 0px"
        }
      }, "Graph C"), /*#__PURE__*/_react.default.createElement(_.Figure, {
        className: "drag_drop_graph",
        srCaption: "placeholder",
        alt: "placeholder",
        src: _calfire.default,
        style: {
          width: "180px"
        }
      })),
      accessible: "placeholder",
      accessibleLabel: "The curvature of the indifference curves increases."
    }],
    feedbackCorrect: "Correct! The shape of the indifference curves captures two important features of the underlying preferences: the curvature of the indifference curves captures the degree of product substitutability, while the slope of the indifference curve at any given point captures the consumer\u2019s relative valuation for the two goods.",
    feedbackIncorrect: "ALL WRONG",
    feedback: [["Incorrect. Think about how the curvature of the indifference curves affect the steepness of the induced demand curve.", "Incorrect. Think about how the curvature of the indifference curves affect the steepness of the induced demand curve..", "Correct! Lower degrees of product substitutability are associated with steeper demand curves, while higher degrees of product substitutability are associated with flatter demand curves."], ["Correct! Lower degrees of product substitutability are associated with steeper demand curves, while higher degrees of product substitutability are associated with flatter demand curves.", "Incorrect. Think about how the curvature of the indifference curves affect the steepness of the induced demand curve.", "Incorrect. Think about how the curvature of the indifference curves affect the steepness of the induced demand curve."], ["Incorrect. Think about how the curvature of the indifference curves affect the steepness of the induced demand curve.", "Correct! Lower degrees of product substitutability are associated with steeper demand curves, while higher degrees of product substitutability are associated with flatter demand curves.", "Incorrect. Think about how the curvature of the indifference curves affect the steepness of the induced demand curve.."]],
    hotspots: [{
      correct: [3],
      hotspotLabel: " ",
      style: {
        top: "0px",
        left: "0px",
        width: "155px",
        height: "145px"
      }
    }, {
      correct: [1],
      hotspotLabel: " ",
      style: {
        top: "0px",
        left: "175px",
        width: "155px",
        height: "145px"
      }
    }, {
      correct: [2],
      hotspotLabel: " ",
      style: {
        top: "0px",
        left: "349px",
        width: "155px",
        height: "145px"
      }
    }, {
      correct: [0],
      hotspotLabel: " ",
      style: {
        top: "0px",
        left: "522px",
        width: "155px",
        height: "145px"
      }
    }]
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      marginBottom: "95px",
      marginTop: "25px"
    },
    src: _cats.default,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, null));
};
Samples["TaskDragDrop Submit"] = SamplesTaskDragDropSubmit;
var SamplesTaskDragDropMulti = function SamplesTaskDragDropMulti(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskDragDrop, {
    state: (0, _.Storage)(),
    labelWidth: "160px",
    labelHeight: "65px",
    responsive: true,
    disableClipping: true,
    submit: true,
    choices: [{
      content: /*#__PURE__*/_react.default.createElement("p", null, "A"),
      accessible: "placeholder",
      accessibleLabel: "x1 doubles, x2 stays the same"
    }, {
      content: /*#__PURE__*/_react.default.createElement("p", null, "B"),
      accessible: "placeholder",
      accessibleLabel: "x1 doubles, x2 triples"
    }, {
      content: /*#__PURE__*/_react.default.createElement("p", null, "C"),
      accessible: "placeholder",
      accessibleLabel: "x1 stays the same, x2 doubles"
    }, {
      content: /*#__PURE__*/_react.default.createElement("p", null, "D"),
      accessible: "placeholder",
      accessibleLabel: "x1 and x2 both double"
    }, {
      content: /*#__PURE__*/_react.default.createElement("p", null, "E"),
      accessible: "placeholder",
      accessibleLabel: "x1 triples, x2 doubles"
    }, {
      content: /*#__PURE__*/_react.default.createElement("p", null, "F"),
      accessible: "placeholder",
      accessibleLabel: "x1 and x2 both triple"
    }],
    feedbackCorrect: "Correct! The shape of the indifference curves captures two important features of the underlying preferences: the curvature of the indifference curves captures the degree of product substitutability, while the slope of the indifference curve at any given point captures the consumer\u2019s relative valuation for the two goods.",
    hotspots: [{
      correct: [0, 4],
      hotspotLabel: " ",
      style: {
        top: "0px",
        left: "15px",
        width: "165px",
        height: "210px"
      }
    }, {
      correct: [1, 2],
      hotspotLabel: " ",
      style: {
        top: "0px",
        left: "260px",
        width: "165px",
        height: "210px"
      }
    }, {
      correct: [3, 5],
      hotspotLabel: " ",
      style: {
        top: "0px",
        left: "495px",
        width: "165px",
        height: "210px"
      }
    }]
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      marginBottom: "95px",
      marginTop: "25px"
    },
    src: _background.default,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement(_.TaskDragDrop.Hotspots, null));
};
Samples["TaskDragDrop Multi"] = SamplesTaskDragDropMulti;
var SamplesTaskFreeResponse = function SamplesTaskFreeResponse(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskFreeResponse, {
    state: (0, _.Storage)(),
    label: "In 1 to 2 sentences, enter your answer.",
    multiline: true,
    style: {
      minHeight: "60px"
    },
    feedbackMissing: "Write something in the field to proceed.",
    minWords: 5
  });
};
Samples["TaskFreeResponse"] = SamplesTaskFreeResponse;
var SamplesTaskFreeResponseNoSubmit = function SamplesTaskFreeResponseNoSubmit(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskFreeResponse, {
    state: (0, _.Storage)(),
    type: "number",
    min: 1,
    max: 9,
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("b", null, "Step 1:"), " Select any number from 1 to 9."),
    noSubmit: true,
    noValueError: "Write something in the field to proceed."
  });
};
Samples["TaskFreeResponse noSubmit"] = SamplesTaskFreeResponseNoSubmit;
var SamplesTaskFreeResponseDefaultValue = function SamplesTaskFreeResponseDefaultValue(props) {
  var _React$useState9 = _react.default.useState("Default value"),
    _React$useState10 = (0, _slicedToArray2.default)(_React$useState9, 2),
    value = _React$useState10[0],
    setValue = _React$useState10[1];
  return /*#__PURE__*/_react.default.createElement(_.TaskFreeResponse, {
    state: (0, _.Storage)(),
    label: "How was your day?",
    description: "Please enter a few words.",
    value: value,
    onChange: function onChange(e) {
      setValue(e.target.value);
    },
    noSubmit: true,
    validators: [{
      test: function test(value, validity) {
        return value.length > 0;
      },
      message: "Please enter at least 3 words to continue."
    }],
    style: {
      height: "6rem"
    },
    multiline: true
  });
};
Samples["TaskFreeResponse default value"] = SamplesTaskFreeResponseDefaultValue;
var SamplesTaskImageClick = function SamplesTaskImageClick(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."), /*#__PURE__*/_react.default.createElement("p", null, "Click the nose to continue."), /*#__PURE__*/_react.default.createElement(_.TaskImageClick, {
    state: (0, _.Storage)(),
    textAdjust: true,
    hotspots: [{
      correct: false,
      label: "Lobster's left ear",
      feedback: "Incorrect. Left ear.",
      shape: "Circle",
      style: {
        top: "150px",
        left: "360px",
        width: "100px",
        height: "50px"
      }
    }, {
      correct: true,
      label: "Lobster's nose",
      feedback: "Correct! Nose.",
      style: {
        top: "185px",
        left: "280px",
        width: "50px",
        height: "50px"
      }
    }, {
      correct: false,
      label: "Lobster's right ear",
      feedback: "Incorrect. Right ear.",
      style: {
        top: "225px",
        left: "370px",
        width: "50px",
        height: "50px"
      }
    }, {
      correct: true,
      label: "Lobster's right ear",
      feedback: "Correct. Right ear.",
      style: {
        top: "325px",
        left: "270px",
        width: "50px",
        height: "50px"
      }
    }]
  }, /*#__PURE__*/_react.default.createElement(_.Figure, {
    srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
    alt: "An orange cat and a black cat.",
    src: _cats.default,
    width: "600px"
  })));
};
Samples["TaskImageClick"] = SamplesTaskImageClick;
var SamplesTaskLikertScale = function SamplesTaskLikertScale(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _cloud.default,
    alt: "A photo of a cloud, taken from inside a car on a long highway.",
    srCaption: "A roadtrip photo of a cloud that looks like a dolphin."
  }), /*#__PURE__*/_react.default.createElement(_.TaskLikertScale, {
    state: (0, _.Storage)(),
    key: "L1",
    prompt: "How does this image make you feel?",
    intervals: 6,
    initialValue: 2,
    labels: ["Opposed", "Concerned", "Unsure", "Mixed Feelings", "Optimistic", "Enthusiastic"],
    legend: "Select how this image makes you feel using the radio buttons below."
  }), /*#__PURE__*/_react.default.createElement(_.TaskLikertScale, {
    state: (0, _.Storage)(),
    key: "L2",
    prompt: "How does this image make you feel?",
    intervals: 6,
    initialValue: 2,
    labels: ["Opposed", "Concerned", "Unsure", "Mixed Feelings", "Optimistic", "Enthusiastic"],
    legend: "Select how this image makes you feel using the radio buttons below."
  }));
};
Samples["TaskLikertScale"] = SamplesTaskLikertScale;
var SamplesTaskLikertScaleWithSubmit = function SamplesTaskLikertScaleWithSubmit(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _cloud.default,
    alt: "A photo of a cloud, taken from inside a car on a long highway.",
    srCaption: "A roadtrip photo of a cloud that looks like a dolphin."
  }), /*#__PURE__*/_react.default.createElement(_.TaskLikertScale, {
    state: (0, _.Storage)(),
    withSubmit: true,
    key: "L1",
    prompt: "How does this image make you feel?",
    intervals: 6,
    labels: [1, 2, 3, 4, 5, 6, 7],
    legend: "Select how this image makes you feel using the radio buttons below."
  }));
};
Samples["TaskLikertScale withSubmit"] = SamplesTaskLikertScaleWithSubmit;
var SamplesTaskMultiChoice = function SamplesTaskMultiChoice(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskMultiChoice, {
    state: (0, _.Storage)(),
    prompt: "Select the fruit that is orange.",
    choices: ["Apple", "Pear", "Orange"],
    correct: [2],
    feedback: ["Incorrect. You selected the apple. ".repeat(99), "Incorrect. You selected the pear.", "Correct! You selected the orange."],
    randomize: false
  }), /*#__PURE__*/_react.default.createElement(_.TaskMultiChoice, {
    state: (0, _.Storage)(),
    prompt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Select the fruit that is orange ", /*#__PURE__*/_react.default.createElement("code", null, "cols=", 2)),
    choices: ["Apple", "Pear", "Orange"],
    correct: [2],
    feedback: ["Incorrect. You selected the apple.", "Incorrect. You selected the pear.", "Correct! You selected the orange."],
    randomize: false,
    cols: 2
  }), /*#__PURE__*/_react.default.createElement(_.TaskMultiChoice, {
    state: (0, _.Storage)(),
    prompt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Select the fruit that is orange ", /*#__PURE__*/_react.default.createElement("code", null, "cols=", 2), ", ", /*#__PURE__*/_react.default.createElement("code", null, "justifyChoices=\"center\"")),
    choices: ["Apple", "Pear", "Orange"],
    correct: [2],
    feedback: ["Incorrect. You selected the apple.", "Incorrect. You selected the pear.", "Correct! You selected the orange."],
    randomize: false,
    cols: 2,
    justifyChoices: "center"
  }), /*#__PURE__*/_react.default.createElement(_.TaskMultiChoice, {
    state: (0, _.Storage)(),
    prompt: "Select the fruit that is orange (noRetry prop).",
    id: "mc-2",
    choices: ["Apple", "Pear", "Orange"],
    correct: [2],
    feedback: ["Incorrect. You selected the apple.", "Incorrect. You selected the pear.", "Correct! You selected the orange."],
    randomize: true,
    maxAttempts: 1
  }));
};
Samples["TaskMultiChoice"] = SamplesTaskMultiChoice;
var SamplesTaskMultiChoiceButton = function SamplesTaskMultiChoiceButton(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Paragraph, {
    text: "this is some text"
  }), /*#__PURE__*/_react.default.createElement(_.TaskMultiChoiceButton, {
    prompt: "Choose the red fruit.",
    state: (0, _.Storage)(),
    buttonWidth: "200px",
    data: [{
      value: "strawberry",
      correct: true,
      feedback: "Correct! Strawberries are red."
    }, {
      value: "This HTML file is a template.If you open it directly in the browser, you will see an empty page.You can add webfonts, meta tags, or analytics to this file.The build step will place the bundled scripts into the <body> tag.To begin the development, run `npm start` or `yarn start`.To create a production bundle, use `npm run build` or `yarn build`.",
      correct: false,
      feedback: "Incorrect. Oranges are orange."
    }, {
      value: "banana",
      correct: false,
      feedback: "Incorrect. Bananas are yellow."
    }, {
      value: "cabbage",
      correct: false,
      feedback: "Incorrect. Cabbages are vegetables."
    }],
    correctFeedback: "Correct.",
    incorrectFeedback: "Incorrect."
  }), /*#__PURE__*/_react.default.createElement(_.TaskMultiChoiceButton, {
    prompt: "Choose the red fruit.",
    state: (0, _.Storage)(),
    buttonWidth: "200px",
    data: [{
      value: /*#__PURE__*/_react.default.createElement("span", null, "strawberry"),
      correct: true,
      feedback: "Correct! Strawberries are red."
    }, {
      value: /*#__PURE__*/_react.default.createElement("span", null, "orange"),
      correct: false,
      feedback: "Incorrect. Oranges are orange."
    }],
    correctFeedback: "Correct.",
    incorrectFeedback: "Incorrect."
  }));
};
Samples["TaskMultiChoiceButton"] = SamplesTaskMultiChoiceButton;
var SamplesTaskMultiSelect = function SamplesTaskMultiSelect(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskMultiSelect, {
    state: (0, _.Storage)(),
    prompt: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Select all fruits that are red"),
    data: [{
      label: /*#__PURE__*/_react.default.createElement("span", null, "Strawberry ", /*#__PURE__*/_react.default.createElement("i", null, "(correct answer)")),
      correct: true
    }, {
      label: "Pomegranate (correct answer)",
      correct: true
    }, {
      label: "Orange",
      correct: false
    }, {
      label: /*#__PURE__*/_react.default.createElement("span", null, "Watermelon"),
      correct: false
    }, {
      label: /*#__PURE__*/_react.default.createElement("span", null, "Banana"),
      correct: false
    }],
    correctFeedback: "Correct.",
    incorrectFeedback: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("i", null, " Try again")),
    maxAttempts: 2,
    randomize: true
  });
};
Samples["TaskMultiSelect"] = SamplesTaskMultiSelect;
var SamplesTaskMultiSelectInstantFeedback = function SamplesTaskMultiSelectInstantFeedback(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskMultiSelect, {
    state: (0, _.Storage)(),
    instantFeedback: true,
    prompt: "Select all fruits that are red",
    data: [{
      label: /*#__PURE__*/_react.default.createElement("span", null, "Strawberry ", /*#__PURE__*/_react.default.createElement("i", null, "(correct answer)")),
      correct: true,
      feedback: "yeah, strawberries are red"
    }, {
      label: "Pomegranate (correct answer)",
      correct: true,
      feedback: "yep, pomegranates are red"
    }, {
      label: "Orange",
      correct: false,
      feedback: "nope, oranges are orange"
    }, {
      label: /*#__PURE__*/_react.default.createElement("span", null, "Watermelon"),
      correct: false,
      feedback: "no, watermelons are green"
    }, {
      label: /*#__PURE__*/_react.default.createElement("span", null, "Banana"),
      correct: false,
      feedback: "nu-uh, bananas are yellow"
    }],
    correctFeedback: "Correct.",
    incorrectFeedback: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("i", null, " Try again"))
  });
};
Samples["TaskMultiSelect Instant Feedback"] = SamplesTaskMultiSelectInstantFeedback;
var SamplesTaskMultiSelectButton = function SamplesTaskMultiSelectButton(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskMultiSelectButton, {
    prompt: "Select all fruits that are red.",
    state: (0, _.Storage)(),
    buttonWidth: "200px",
    data: [{
      value: "strawberry",
      correct: true
    }, {
      value: "pomegranate",
      correct: true
    }, {
      value: "cherry",
      correct: true
    }, {
      value: "orange",
      correct: false
    }, {
      value: "banana",
      correct: false
    }, {
      value: "cabbage",
      correct: false
    }],
    correctFeedback: "Correct.",
    incorrectFeedback: "Incorrect."
  }));
};
Samples["TaskMultiSelectButton"] = SamplesTaskMultiSelectButton;
var SamplesTaskMusicViewer = function SamplesTaskMusicViewer(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TaskMusicViewer.default, {
    alt: "Accessible description of the score",
    staffWidth: "50%",
    longAlt: "This is an example of a longer alt text for a score, this could include more information about the notes on the staff, or be used in case there is a long stanza, and short alt is not enough",
    scoreCredit: "Shutterstock",
    rawAbc: "X: 1\nT: Cooley's\nM: 4/4\nL: 1/8\nR: reel\nK: Emin\n|:D2|EB{c}BA B2 EB|~B2 AB dBAG|FDAD BDAD|FDAD dAFD|\nEBBA B2 EB|B2 AB defg|afe^c dBAF|DEFD E2:|\n|:gf|eB B2 efge|eB B2 gedB|A2 FA DAFA|A2 FA defg|\neB B2 eBgB|eB B2 defg|afe^c dBAF|DEFD E2:|"
  }));
};
Samples["TaskMusicViewer"] = SamplesTaskMusicViewer;
var SamplesTaskMusicPlayer = function SamplesTaskMusicPlayer(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskMusicPlayer, {
    state: (0, _.Storage)(),
    musicDuration: 2000,
    notation: "X:1 \n      L:1/1 \n      M: \n      K:Cmin bass \n      _E,F,G,_A,_B,"
  }));
};
Samples["TaskMusicPlayer"] = SamplesTaskMusicPlayer;
var SamplesTaskPassageClick = function SamplesTaskPassageClick(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskPassageClick, {
    state: (0, _.Storage)(),
    finalFeedback: "This is what having a final feedback looks like!",
    prompt: "answer the question."
  }, "Lorem", " ", /*#__PURE__*/_react.default.createElement(_.TaskPassageClick.Click, {
    correct: true,
    feedback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. ", /*#__PURE__*/_react.default.createElement("br", null), "Sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus? Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. Stet clita kasd gubergren, no sea takimata sanctus? Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. Stet clita kasd gubergren, no sea takimata sanctus? Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.")
  }, "ipsum"), " ", "dolor", " ", /*#__PURE__*/_react.default.createElement(_.TaskPassageClick.Click, {
    feedback: "Incorrect."
  }, "sit amet"), ", consectetur adipiscing elit,", " ", /*#__PURE__*/_react.default.createElement(_.TaskPassageClick.Click, {
    correct: true,
    feedback: "Correct! 2"
  }, "sed do eiusmod tempor incididunt ut labore"), " ", "et dolore magna aliqua. Ut enim ad ", " ", /*#__PURE__*/_react.default.createElement(_.TaskPassageClick.Click, {
    feedback: "Incorrect. 2"
  }, "minimveniam, quis"), "nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit", /*#__PURE__*/_react.default.createElement(_.TaskPassageClick.Click, {
    feedback: "Incorrect. 2"
  }, "esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non"), "proident, sunt in culpa qui officia deserunt mollit anim id est laborum."));
};
Samples["TaskPassageClick"] = SamplesTaskPassageClick;
var SamplesTaskPassageReveal = function SamplesTaskPassageReveal(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal, {
    state: (0, _.Storage)()
  }, /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal.Passage, {
    color: "#99ccff"
  }, "Lorem ipsum dolor sit amet , consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."), " ", "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."));
};
Samples["TaskPassageReveal"] = SamplesTaskPassageReveal;
var SamplesTaskPassageHover = function SamplesTaskPassageHover(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal, {
    state: (0, _.Storage)(),
    noReveal: true
  }, "Lorem ipsum dolor", " ", /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal.Passage, {
    contents: "This is the first line of an old latin phrase that is frequently used as text filler.",
    exitOnHover: true
  }, "sit amet , consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."), " ", "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit ", /*#__PURE__*/_react.default.createElement(_.TaskPassageReveal.Passage, {
    contents: "This is the only English word in the text."
  }, "in"), " voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."));
};
Samples["TaskPassageHover"] = SamplesTaskPassageHover;
var SamplesTaskRank = function SamplesTaskRank(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Order the options from least to greatest."), /*#__PURE__*/_react.default.createElement(_.TaskRank, {
    state: (0, _.Storage)(),
    rank: ["1", "2", "3", "4", "5"],
    options: ["option1", "option2", "option3", "option4", "option5"],
    correct: ["option1", "option2", "option3", "option4", "option5"],
    correctFeedback: "Correct.",
    incorrectFeedback: "Incorrect."
  }));
};
Samples["TaskRank"] = SamplesTaskRank;
var SamplesTable = function SamplesTable(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Order the options from least to greatest."), /*#__PURE__*/_react.default.createElement(_.Table, {
    contents: [[{
      data: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "hi"),
      isHeader: true,
      colSpan: 2
    }, {
      data: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "hi", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
        caption: "Lobster (left) and Dashiell (right) laying in a chair.",
        alt: "An orange cat and a black cat.",
        src: _cats.default,
        width: "100%",
        style: {
          transform: "scaleX(1)"
        }
      })),
      isHeader: true
    }], [{
      data: /*#__PURE__*/_react.default.createElement(_.TaskTree, {
        state: (0, _.Storage)(),
        id: "one",
        children: /*#__PURE__*/_react.default.createElement("p", null, "You take the left door and go through it into a room with no exits but one window, which is boarded up tight."),
        paths: []
      }),
      isHeader: false
    }, {
      data: /*#__PURE__*/_react.default.createElement(_.TaskTrueFalse, {
        state: (0, _.Storage)(),
        key: "TF2",
        question: "The sky is red.",
        correct: "true",
        correctFeedback: "The red color comes from the reflection of the sea of fire.",
        incorrectFeedback: "Incorrect."
      }),
      isHeader: false
    }, {
      data: /*#__PURE__*/_react.default.createElement(_.TaskTree, {
        state: (0, _.Storage)(),
        id: "one",
        children: /*#__PURE__*/_react.default.createElement("p", null, "You take the left door and go through it into a room with no exits but one window, which is boarded up tight."),
        paths: []
      }),
      isHeader: false
    }]]
  }));
};
Samples["Table"] = SamplesTable;
var SamplesTaskScaleBuilder = function SamplesTaskScaleBuilder(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Adjust the E&flat; major pentachord below in order to create an E&flat; minor pentachord."), /*#__PURE__*/_react.default.createElement(_.TaskScaleBuilder, {
    state: (0, _.Storage)(),
    key: "s4",
    feedbackIncorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Use the interval pattern W-H-W-W to create a minor pentachord."),
    musicStaffWidth: "95%",
    musicDuration: 1000,
    musicConfiguration: "X:1;L:1/1;M:;K:C treble",
    musicInitial: "\"_B3\"z|\"_C6\"z|\"_D4\"z|\"_B5\"z|\"_F3\"z|\"_C4\"z|\"_E6\"z|\"_A5\"z|\"_A3\"z|\"_D6\"z",
    perNoteAnnotationAltText: "B3,C6,D4,B5,F3,C4,E6,A5,A3,D6",
    correct: "\"_B3\"B,|\"_C6\"C''|\"_D4\"D|\"_B5\"B'|\"_F3\"F,|\"_C4\"C|\"_E6\"E''|\"_A5\"A'|\"_A3\"A,|\"_D6\"D''",
    musicButtonNote: true,
    musicButtonNatural: true,
    musicButtonFlat: true,
    musicButtonDoubleFlat: true,
    musicButtonSharp: true,
    musicButtonDoubleSharp: true,
    musicButtonAudio: true,
    zoom: 1.25,
    rangeLower: -4,
    rangeUpper: 16,
    feedbackCorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "The difference between a major pentachord and a minor pentachord is the third scale degree. In the minor pentachord, use &flat;", /*#__PURE__*/_react.default.createElement("math", null, /*#__PURE__*/_react.default.createElement("mover", null, /*#__PURE__*/_react.default.createElement("mn", null, "3"), /*#__PURE__*/_react.default.createElement("mo", null, "\u0302"))), " ", "(", /*#__PURE__*/_react.default.createElement("i", null, "me"), ").")
  }));
};
Samples["TaskScaleBuilder"] = SamplesTaskScaleBuilder;
var SamplesTaskScaleBuilderAll = function SamplesTaskScaleBuilderAll(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Create a D major scale with the Scale Builder below."), /*#__PURE__*/_react.default.createElement(_.TaskScaleBuilder, {
    state: (0, _.Storage)(),
    feedbackIncorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "One or more of your notes are incorrect."),
    musicStaffWidth: "100%",
    musicDuration: 750,
    musicConfiguration: "X:1;L:1/1;M:;K:C treble",
    musicInitial: "zzzzzzzz",
    annotationAltText: "",
    musicButtonAudio: true,
    musicButtonNatural: true,
    musicButtonSharp: true,
    musicButtonFlat: true,
    musicButtonNote: true,
    optionStyling: true,
    minHeight: "140px",
    zoom: 1.25,
    iconOffsets: {
      xOffset: 6,
      yOffsetNoAnnotation: 10,
      yOffsetWithAnnotation: 25
    },
    rangeLower: -4,
    rangeUpper: 16,
    answers: [{
      answer: "AB=C'D'E'=F'=G'A'",
      correct: true,
      feedback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Your scale is correct.")
    }, {
      answer: "ABC'D'E'F'G'A'",
      correct: false,
      feedback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Be sure to use naturals.")
    }]
  }));
};
Samples["TaskScaleBuilderAll"] = SamplesTaskScaleBuilderAll;
var SamplesTaskSelect = function SamplesTaskSelect(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    matchWidth: "button",
    options:
    // if you need to readout specific text to screen reader and display different text
    [/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "A"), /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "Apples")), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "O"), /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "Orange")), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "P"), /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "Pears"))],
    label: "Select the fruit with the most vitamin C.",
    feedback: [/*#__PURE__*/_react.default.createElement("span", null, "Incorrect. An apple contains 8.4 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Correct. An orange contains 51.1 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Incorrect. A pear contains 7 mg of vitamin C.")],
    correct: 1,
    buttonWidth: "145px",
    optionStyling: true
  }));
};
Samples["TaskSelect"] = SamplesTaskSelect;
var SamplesTaskSelectRow = function SamplesTaskSelectRow(props) {
  return /*#__PURE__*/_react.default.createElement(_DesignComponents.DesignRow, null, /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    options: ["Apples", "Oranges", "Pears"],
    label: "Select the fruit with the most vitamin C.",
    feedback: [/*#__PURE__*/_react.default.createElement("span", null, "Incorrect. An apple contains 8.4 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Correct. An orange contains 51.1 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Incorrect. A pear contains 7 mg of vitamin C.")],
    correct: 1,
    buttonWidth: "95px"
  }), /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    options: ["Apples", "Oranges", "Pears"],
    label: "Select the fruit with the most vitamin C.",
    feedback: [/*#__PURE__*/_react.default.createElement("span", null, "Incorrect. An apple contains 8.4 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Correct. An orange contains 51.1 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Incorrect. A pear contains 7 mg of vitamin C.")],
    correct: 1,
    buttonWidth: "55px"
  }), /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    options: ["Apples", "Oranges", "Pears"],
    label: "Select the fruit with the most vitamin C.",
    feedback: [/*#__PURE__*/_react.default.createElement("span", null, "Incorrect. An apple contains 8.4 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Correct. An orange contains 51.1 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Incorrect. A pear contains 7 mg of vitamin C.")],
    correct: 1,
    buttonWidth: "75px"
  }), /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    options: ["Apples", "Oranges", "Pears"],
    label: "Select the fruit with the most vitamin C.",
    feedback: [/*#__PURE__*/_react.default.createElement("span", null, "Incorrect. An apple contains 8.4 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Correct. An orange contains 51.1 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Incorrect. A pear contains 7 mg of vitamin C.")],
    correct: 1,
    buttonWidth: "175px"
  }));
};
Samples["TaskSelect Row"] = SamplesTaskSelectRow;
var SamplesTaskSelectNoModal = function SamplesTaskSelectNoModal(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    noModal: true,
    options: ["Apples", "Oranges", "Pears"],
    label: "Select the fruit with the most vitamin C.",
    feedback: [/*#__PURE__*/_react.default.createElement("span", null, "Incorrect. An apple contains 8.4 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Correct. An orange contains 51.1 mg of vitamin C."), /*#__PURE__*/_react.default.createElement("span", null, "Incorrect. A pear contains 7 mg of vitamin C.")],
    correct: 1
  }));
};
Samples["TaskSelect No Modal"] = SamplesTaskSelectNoModal;

// Use 'label' and 'description' to insert text before and after.
var SamplesTaskSelectInline = function SamplesTaskSelectInline(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "this is some text\xA0"), /*#__PURE__*/_react.default.createElement(_.TaskSelect, {
    state: (0, _.Storage)(),
    options: ["Apples", "Oranges", "Pears"],
    label: /*#__PURE__*/_react.default.createElement("span", null, "In general, "),
    description: /*#__PURE__*/_react.default.createElement("span", null, "are a good source of Vitamin C."),
    correct: 1,
    inline: true,
    srOnly: true
  }), /*#__PURE__*/_react.default.createElement("span", null, "\xA0this is also some text"));
};
Samples["TaskSelect Inline"] = SamplesTaskSelectInline;
var SamplesTaskSlider = function SamplesTaskSlider(props) {
  var faces = ["D:", "):", ":|", ":)", ":D"];
  var _React$useState11 = _react.default.useState(0),
    _React$useState12 = (0, _slicedToArray2.default)(_React$useState11, 2),
    face = _React$useState12[0],
    setFace = _React$useState12[1];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
    style: {
      textAlign: "center"
    },
    "aria-live": "polite",
    "aria-atomic": "false"
  }, faces[face]), /*#__PURE__*/_react.default.createElement(_.TaskSlider, {
    key: "111",
    min: 0,
    max: 4,
    start: 0,
    step: 1,
    tooltip: "off",
    handleChange: function handleChange(x) {
      setFace(x);
    }
  }));
};
Samples["TaskSlider"] = SamplesTaskSlider;
var SamplesTaskSorting = function SamplesTaskSorting(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Varius vel pharetra vel turpis. Elit at imperdiet dui accumsan sit. Quam adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus. Ac feugiat sed lectus vestibulum mattis ullamcorper velit sed ullamcorper. Etiam tempor orci eu lobortis elementum. Ultricies lacus sed turpis tincidunt id aliquet. Tristique et egestas quis ipsum suspendisse ultrices. In eu mi bibendum neque egestas congue. Suscipit adipiscing bibendum est ultricies. ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    text: "(\\frac{x_2}{x_1})",
    scale: 1.3
  }), " Tincidunt id aliquet risus feugiat in ante metus dictum at. Mauris augue neque gravida in fermentum et sollicitudin?"), /*#__PURE__*/_react.default.createElement(_.TaskSorting, {
    state: (0, _.Storage)(),
    feedbackCorrect: "Correct Feedback",
    feedbackIncorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      text: "(\\frac{x_2}{x_1})",
      scale: 1.3
    })),
    prompt: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    categories: [/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MathJax.default, {
      text: "x_2 = x_1"
    }), " Category #1"), "Testing Long Category Text #2"]
  }, /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 0
  }, "1. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, "2. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod. ", /*#__PURE__*/_react.default.createElement(_MathJax.default, {
    text: "(\\frac{x_2}{x_1})",
    scale: 1.3
  })), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, "mj"), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, "ab"), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, "et, consectetur adipiscing elit,")));
};
Samples["TaskSorting"] = SamplesTaskSorting;
var SamplesTaskSortingRandomize = function SamplesTaskSortingRandomize(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskSorting, {
    state: (0, _.Storage)(),
    feedbackCorrect: "Correct Feedback",
    feedbackIncorrect: "Incorrect Feedback",
    prompt: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Varius vel pharetra vel turpis. Elit at imperdiet dui accumsan sit. Quam adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus. Ac feugiat sed lectus vestibulum mattis ullamcorper velit sed ullamcorper. Etiam tempor orci eu lobortis elementum. Ultricies lacus sed turpis tincidunt id aliquet. Tristique et egestas quis ipsum suspendisse ultrices. In eu mi bibendum neque egestas congue.  Suscipit adipiscing bibendum est ultricies. Tincidunt id aliquet risus feugiat in ante metus dictum at. Mauris augue neque gravida in fermentum et sollicitudin?",
    categories: ["Category #1", "Testing Long Category Text #2"],
    randomize: true
  }, /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 0
  }, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, "Option 3")));
};
Samples["TaskSorting randomize"] = SamplesTaskSortingRandomize;
var SamplesTaskSortingImages = function SamplesTaskSortingImages(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskSorting, {
    state: (0, _.Storage)(),
    feedbackCorrect: "Correct Feedback",
    feedbackIncorrect: "Incorrect Feedback",
    prompt: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Varius vel pharetra vel turpis. Elit at imperdiet dui accumsan sit. Quam adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus. Ac feugiat sed lectus vestibulum mattis ullamcorper velit sed ullamcorper. Etiam tempor orci eu lobortis elementum. Ultricies lacus sed turpis tincidunt id aliquet. Tristique et egestas quis ipsum suspendisse ultrices. In eu mi bibendum neque egestas congue.  Suscipit adipiscing bibendum est ultricies. Tincidunt id aliquet risus feugiat in ante metus dictum at. Mauris augue neque gravida in fermentum et sollicitudin?",
    categories: ["Category #1", "Category #2"]
  }, /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 0
  }, /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _cats.default,
    alt: "An orange cat and a black cat.",
    caption: /*#__PURE__*/_react.default.createElement("i", {
      style: {
        fontSize: "10px"
      }
    }, "Lorem ipsum dolor sit amet"),
    srCaption: "Lobster (left) and Dashiell (right) laying in a chair.",
    style: {
      width: "196px"
    }
  })), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _TestVerticalImage.default,
    alt: "A photo of a cloud, taken from inside a car on a long highway.",
    caption: /*#__PURE__*/_react.default.createElement("i", {
      style: {
        fontSize: "10px"
      }
    }, "Lorem ipsum dolor sit amet"),
    srCaption: "A roadtrip photo of a cloud that looks like a dolphin.",
    style: {
      width: "196px",
      maxHeight: "110px",
      objectFit: "none"
    }
  })), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _calfire.default,
    alt: "A photo of the sun. Smoke in the air turns the light red.",
    caption: /*#__PURE__*/_react.default.createElement("i", {
      style: {
        fontSize: "10px"
      }
    }, "Lorem ipsum dolor sit amet"),
    srCaption: "A photo of the sun during the 2020 California wildfire season.",
    style: {
      width: "196px"
    }
  }))));
};
Samples["TaskSortingImages"] = SamplesTaskSortingImages;
var SamplesTaskSortingMulti = function SamplesTaskSortingMulti(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskSorting, {
    state: (0, _.Storage)(),
    feedbackCorrect: "Correct Feedback",
    feedbackIncorrect: "Incorrect Feedback",
    prompt: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Varius vel pharetra vel turpis. Elit at imperdiet dui accumsan sit. Quam adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus. Ac feugiat sed lectus vestibulum mattis ullamcorper velit sed ullamcorper. Etiam tempor orci eu lobortis elementum. Ultricies lacus sed turpis tincidunt id aliquet. Tristique et egestas quis ipsum suspendisse ultrices. In eu mi bibendum neque egestas congue.  Suscipit adipiscing bibendum est ultricies. Tincidunt id aliquet risus feugiat in ante metus dictum at. Mauris augue neque gravida in fermentum et sollicitudin?",
    categories: ["Category #1", "Category #2", "Category #3", "Category #4"],
    maxOptionsPerRow: 3
  }, /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 0
  }, /*#__PURE__*/_react.default.createElement("b", null, "Answer: Category #1."), " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, /*#__PURE__*/_react.default.createElement("b", null, "Answer: Category #2."), " Lorem ipsum dolor sit amet."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 1
  }, /*#__PURE__*/_react.default.createElement("b", null, "Answer: Category #2."), " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 2
  }, /*#__PURE__*/_react.default.createElement("b", null, "Answer: Category #3."), " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 3
  }, /*#__PURE__*/_react.default.createElement("b", null, "Answer: Category #4."), " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 3
  }, /*#__PURE__*/_react.default.createElement("b", null, "Answer: Category #4."), " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."), /*#__PURE__*/_react.default.createElement(_.TaskSorting.Option, {
    category: 3
  }, /*#__PURE__*/_react.default.createElement("b", null, "Answer: Category #4."), " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.")));
};
Samples["TaskSortingMulti"] = SamplesTaskSortingMulti;
var SamplesTaskTabPanel = function SamplesTaskTabPanel(props) {
  return /*#__PURE__*/_react.default.createElement(_.TaskTabPanel, {
    state: (0, _.Storage)(),
    label: "Cat pictures",
    contents: [{
      title: "Tab 1",
      contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "hi", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
        caption: "Lobster (left) and Dashiell (right) laying in a chair.",
        alt: "An orange cat and a black cat.",
        src: _cats.default,
        width: "100%",
        style: {
          transform: "scaleX(1)"
        }
      }))
    }, {
      title: "Tab 2",
      contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "hello", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
        caption: "Dashiell (left) and Lobster (right) laying in a chair.",
        alt: "A black cat and an orange cat.",
        src: _cats.default,
        width: "100%",
        style: {
          transform: "scaleX(-1)"
        }
      }))
    }, {
      title: "Tab 3 Very Long Title",
      contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "goodbye", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
        caption: "Lobster (left) and Dashiell (right) laying in a chair, upside-down.",
        alt: "An orange cat and a black cat, upside-down.",
        src: _cats.default,
        width: "100%",
        style: {
          transform: "scaleY(-1)"
        }
      }))
    }, {
      title: "Tab 4",
      contents: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "bye", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_.Figure, {
        caption: "Dashiell (left) and Lobster (right) laying in a chair, upside-down.",
        alt: "A black cat and an orange cat, upside-down.",
        src: _cats.default,
        width: "100%",
        style: {
          transform: "scaleX(-1) scaleY(-1)"
        }
      }))
    }]
  });
};
Samples["TaskTabPanel"] = SamplesTaskTabPanel;
var SamplesTaskTree = function SamplesTaskTree(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskTree, {
    state: (0, _.Storage)(),
    id: "root",
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "You come across two doors."), /*#__PURE__*/_react.default.createElement("p", null, "Which door do you choose?")),
    paths: [{
      buttonProps: {
        children: "Door 1"
      },
      content: /*#__PURE__*/_react.default.createElement(_.TaskTree, {
        state: (0, _.Storage)(),
        id: "one",
        children: /*#__PURE__*/_react.default.createElement("p", null, "You take the left door and go through it into a room with no exits but one window, which is boarded up tight."),
        paths: []
      })
    }, {
      buttonProps: {
        children: "Door 2"
      },
      content: /*#__PURE__*/_react.default.createElement(_.TaskTree, {
        state: (0, _.Storage)(),
        id: "two",
        children: /*#__PURE__*/_react.default.createElement("p", null, "You open the right door to find yourself in another large chamber. There are many doors leading out of this room."),
        paths: [{
          buttonProps: {
            children: "Path A"
          },
          content: /*#__PURE__*/_react.default.createElement(_.TaskTree, {
            state: (0, _.Storage)(),
            id: "three",
            children: /*#__PURE__*/_react.default.createElement("p", null, "You take path A. It's a dead end."),
            paths: []
          })
        }, {
          buttonProps: {
            children: "Path B"
          },
          content: /*#__PURE__*/_react.default.createElement(_.TaskTree, {
            state: (0, _.Storage)(),
            id: "four",
            children: /*#__PURE__*/_react.default.createElement("p", null, "You take path B. It's a dead end."),
            paths: []
          })
        }, {
          buttonProps: {
            children: "Path C"
          },
          content: /*#__PURE__*/_react.default.createElement(_.TaskTree, {
            state: (0, _.Storage)(),
            id: "five",
            children: /*#__PURE__*/_react.default.createElement("p", null, "You take path C. It's a dead end."),
            paths: []
          })
        }]
      })
    }]
  }));
};
Samples["TaskTree"] = SamplesTaskTree;
var SamplesTaskTrueFalse = function SamplesTaskTrueFalse(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Figure, {
    src: _calfire.default,
    alt: "A photo of the sun. Smoke in the air turns the light red.",
    caption: "A photo of the sun during the 2020 California wildfire season."
  }), /*#__PURE__*/_react.default.createElement(_.TaskTrueFalse, {
    state: (0, _.Storage)(),
    key: "TF2",
    question: "The sky is red.",
    correct: "true",
    correctFeedback: "The red color comes from the reflection of the sea of fire.",
    incorrectFeedback: "Incorrect."
  }));
};
Samples["TaskTrueFalse"] = SamplesTaskTrueFalse;
var SamplesTaskVoiceBuilder = function SamplesTaskVoiceBuilder(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.TaskVoiceBuilder, {
    state: (0, _.Storage)(),
    key: "c3",
    musicConfiguration: "X:1;L:1/4;M:;K:;%%stretchlast;%%staves {(S A) (T B)} ",
    musicInitial: "A B C' ||; D E F ||; A, B, C, ||; D, E, F,, ||",
    correct: "A A A ||; D D D ||; A, A, A, ||; D, D, D, ||",
    musicDuration: 1000,
    musicButton: true,
    musicButtonFlat: true,
    musicButtonSharp: true,
    musicButtonNatural: false,
    musicButtonSATB: true,
    musicButtonSoprano: true,
    musicButtonAlto: true,
    musicButtonTenor: true,
    musicButtonBass: true,
    feedbackCorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "In an augmented triad, the interval between the root and third is a major third and the interval between the root and fifth is an augmented fifth. So, F\u2013A\u2013", /*#__PURE__*/_react.default.createElement("strong", null, "C\u266F"), " spells an augmented triad on an F root."),
    feedbackIncorrect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Listen to the triad again. It contains a major third between the root and third. What is the quality of the interval between the root and fifth?")
  }));
};
Samples["TaskVoiceBuilder"] = SamplesTaskVoiceBuilder;